// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MyForm.css */

.my-form-container {
    /* max-width: 500px; */
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .my-form-container .message-box{
    top: 25px;
    position: fixed !important;
  }
  
  .form-title {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
  }
  
  .form {
    display: grid;
    gap: 15px;
  }
  
  .form-field {
    display: flex;
    flex-direction: column;
  }
  
  .form-label {
    font-size: 16px;
    margin-bottom: 5px;
    color: #444;
  }
  
  .form-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
  }
  
  .error {
    color: #ff0000;
    font-size: 14px;
    margin-top: 5px;
  }
  
  .submit-button {
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 18px;
    cursor: pointer;
  }
  
  .submit-button:hover {
    background-color: #0056b3;
  }

  
  .my-form-container .form-input:not([type=radio]):not([type=checkbox]) {
    width: auto !important;
  }


  /* Apply general styling to error fields */
.error {
    border: 1px solid #ff0000; /* Red border for error fields */
  }
  
  /* Style for the error tooltip */
  .error-tooltip {
    color: #ff0000; /* Red text color for the error message */
    font-size: 0.8rem; /* Adjust the font size as needed */
    margin-top: 5px; /* Spacing between the field and the error message */
    display: block;
  }
  
.label-table-container{
  overflow: auto;
}
.label-table-container .table-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  margin: 1rem; /* Add some spacing around the table */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow for depth */
}

.label-table-container .table-container table {
  /* width: 100%; /* Full width of the container */
  width: auto !important;
  border-collapse: collapse; /* Collapse borders */
  background-color: #fff; /* White background for the table */
}

.label-table-container .table-container th, td {
  padding: 0.5rem 1rem; /* Padding for table cells */
  text-align: left; /* Align text to the left */
  border-bottom: 1px solid #ddd; /* Light grey border for rows */
}

.label-table-container .table-container th {
  background-color: #f8f8f8; /* Slightly grey background for headers */
  font-weight: bold; /* Make header text bold */
}

.label-table-container .table-container tr:hover {
  background-color: #f1f1f1; /* Highlight row on hover */
}

/* Responsive table */
@media screen and (max-width: 600px) {
  .label-table-container .table-container {
    margin: 0; /* Remove margin in small screens */
  }
  .label-table-container .table-container th, td {
    padding: 0.5rem; /* Smaller padding for small screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Components/MyForm.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,sBAAsB;EACxB;;;EAGA,0CAA0C;AAC5C;IACI,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA,gCAAgC;EAChC;IACE,cAAc,EAAE,yCAAyC;IACzD,iBAAiB,EAAE,mCAAmC;IACtD,eAAe,EAAE,oDAAoD;IACrE,cAAc;EAChB;;AAEF;EACE,cAAc;AAChB;AACA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,YAAY,EAAE,sCAAsC;EACpD,uCAAuC,EAAE,kCAAkC;AAC7E;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;EACtB,yBAAyB,EAAE,qBAAqB;EAChD,sBAAsB,EAAE,mCAAmC;AAC7D;;AAEA;EACE,oBAAoB,EAAE,4BAA4B;EAClD,gBAAgB,EAAE,2BAA2B;EAC7C,6BAA6B,EAAE,+BAA+B;AAChE;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,qBAAqB;AACrB;EACE;IACE,SAAS,EAAE,mCAAmC;EAChD;EACA;IACE,eAAe,EAAE,sCAAsC;EACzD;AACF","sourcesContent":["/* MyForm.css */\n\n.my-form-container {\n    /* max-width: 500px; */\n    margin: 0 auto;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n\n  .my-form-container .message-box{\n    top: 25px;\n    position: fixed !important;\n  }\n  \n  .form-title {\n    font-size: 24px;\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  .form {\n    display: grid;\n    gap: 15px;\n  }\n  \n  .form-field {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .form-label {\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #444;\n  }\n  \n  .form-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n  }\n  \n  .error {\n    color: #ff0000;\n    font-size: 14px;\n    margin-top: 5px;\n  }\n  \n  .submit-button {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 18px;\n    cursor: pointer;\n  }\n  \n  .submit-button:hover {\n    background-color: #0056b3;\n  }\n\n  \n  .my-form-container .form-input:not([type=radio]):not([type=checkbox]) {\n    width: auto !important;\n  }\n\n\n  /* Apply general styling to error fields */\n.error {\n    border: 1px solid #ff0000; /* Red border for error fields */\n  }\n  \n  /* Style for the error tooltip */\n  .error-tooltip {\n    color: #ff0000; /* Red text color for the error message */\n    font-size: 0.8rem; /* Adjust the font size as needed */\n    margin-top: 5px; /* Spacing between the field and the error message */\n    display: block;\n  }\n  \n.label-table-container{\n  overflow: auto;\n}\n.label-table-container .table-container {\n  overflow-x: auto; /* Enable horizontal scrolling */\n  margin: 1rem; /* Add some spacing around the table */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle shadow for depth */\n}\n\n.label-table-container .table-container table {\n  /* width: 100%; /* Full width of the container */\n  width: auto !important;\n  border-collapse: collapse; /* Collapse borders */\n  background-color: #fff; /* White background for the table */\n}\n\n.label-table-container .table-container th, td {\n  padding: 0.5rem 1rem; /* Padding for table cells */\n  text-align: left; /* Align text to the left */\n  border-bottom: 1px solid #ddd; /* Light grey border for rows */\n}\n\n.label-table-container .table-container th {\n  background-color: #f8f8f8; /* Slightly grey background for headers */\n  font-weight: bold; /* Make header text bold */\n}\n\n.label-table-container .table-container tr:hover {\n  background-color: #f1f1f1; /* Highlight row on hover */\n}\n\n/* Responsive table */\n@media screen and (max-width: 600px) {\n  .label-table-container .table-container {\n    margin: 0; /* Remove margin in small screens */\n  }\n  .label-table-container .table-container th, td {\n    padding: 0.5rem; /* Smaller padding for small screens */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
